import { render, staticRenderFns } from "./SmatHeader.vue?vue&type=template&id=cd435b1c&"
import script from "./SmatHeader.vue?vue&type=script&lang=js&"
export * from "./SmatHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports